import { call, put, takeEvery } from "redux-saga/effects";
import { lopTinChiApi } from "../../../api/lop-tin-chi/lopTinChiApi";
import { ILopTinChiSelectRequest } from "../../../model/request/lop-tin-chi/ILopTinChiSelectRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eLopTinChiKetQuaActionIds, ILopTinChiKetQuaActionTypes } from "../../action-types/lop-tin-chi/ILopTinChiKetQuaActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.lopTinChiWrapper.lopTinChiKetQua;
export function* lopTinChiKetQuaSaga(): any {
  yield takeEvery(eLopTinChiKetQuaActionIds.LOAD_START, loadWorker);
}

function* loadWorker(action: ILopTinChiKetQuaActionTypes): any {
  const res: IBaseRespone = yield call(lopTinChiApi.SelectKetQua, action.payload as ILopTinChiSelectRequest);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
